import styled from 'styled-components';
import { ModalBody, ModalContent, ModalFooter, ModalHeader } from '@web-chat-core/ui-kit';

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 12px 0 16px 0;
`;

export const TimerWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    top: -12px;
    pointer-events: none;
`;

export const StyledModalBody = styled(ModalBody)`
    background: ${({ theme }) => theme.root.colors.background.sheetOrModal};
`;

export const StyledModalHeader = styled(ModalHeader)`
    padding-bottom: 0px;
`;

export const StyledModalContent = styled(ModalContent)`
    overflow: visible;
`;

export const StyledModalFooter = styled(ModalFooter)`
    justify-content: center;
`;
